import React from 'react'
import {Route, IndexRoute} from 'react-router'
import Layout from './Layout'
import Users from './Users'
import UserInformation from './UserInformation'
import OrganizationsData from './OrganizationsData'
import OrgInformation from './OrgInformation'
import Document from 'src/App/Pages/Documents/Document'
import Preview from 'src/App/Pages/Documents/Preview'
// import CodeDiscount from './CodeDiscount'

export default (
  <Route path="/admin" component={Layout}>
    <IndexRoute component={Users} />
    <Route path="organizationsdata" component={OrganizationsData} />
    <Route path=":_id" component={UserInformation} />
    <Route path="organizationsdata/:organizationId" component={OrgInformation} />
    <Route path=":_id/:documentId" component={Document} />
    <Route path=":_id/:documentId/preview" component={Preview} />
    {/* <Route path="codediscount" component={CodeDiscount} /> */}
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/index.js